import { render, staticRenderFns } from "./CardSkeleton.vue?vue&type=template&id=68ebf81d&"
import script from "./CardSkeleton.vue?vue&type=script&lang=js&"
export * from "./CardSkeleton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports